import React from 'react';
import Select from 'react-select';

const ComDeliveryEditor = ({
    initialData,
    activeDomains,
    onDataChange,
}) => {
    const [form, setForm] = React.useState({
        domainFrom: (initialData?.domainFrom && (activeDomains.includes(initialData.domainFrom) || initialData.domainFrom === 'all'))
            ? initialData.domainFrom
            : 'all',
        deliveryMethod: initialData?.deliveryMethod || 'microsoft',
        transportServer: initialData?.transportServer || '',
        transportPort: initialData?.transportPort || '',
        transportUser: initialData?.transportUser || '',
        transportPass: initialData?.transportPass || '',
    });
    const [showPassword, setShowPassword] = React.useState(false);
    const isMobile = (window.innerWidth < 768);
    const commonSelectProps = {
        getOptionLabel: (e) => e.value,
        getOptionValue: (e) => e.key,
        isSearchable: !isMobile,
        isClearable: false,
        filterOption: (option, inputValue) => {
            const { value, key } = option.data;
            return (
                value.toLowerCase().includes(inputValue.toLowerCase()) ||
                key.toLowerCase().includes(inputValue.toLowerCase())
            );
        },
    };

    React.useEffect(() => {
        onDataChange && onDataChange(form);
    }, [form]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const domainOptions = [
        { key: 'all', value: 'All Domains' },
        ...activeDomains.map(d => ({ key: d, value: d })),
    ];

    const methodOptions = [
        { key: 'microsoft', value: 'Microsoft 365' },
        { key: 'custom', value: 'Custom SMTP' },
        { key: 'mimecast', value: 'Mimecast' },
    ];

    return (
        <div className="text-start">
            <p className="mb-3 text-center">
                Configure how processed emails are delivered back to your mail server or destination.
            </p>
            <div className={"row " + (form.deliveryMethod === 'custom' ? '' : 'mb-4')}>
                <div className={"col-12 fs-7 " + (form.deliveryMethod === 'custom' ? '' : 'mb-5')}>

                    {/* Domain From */}
                    <div className="row align-items-center mb-2">
                        <label className="col-4 col-form-label">Domain From:</label>
                        <div className="col-8">
                            <Select
                                {...commonSelectProps}
                                id="domainFrom"
                                name="domainFrom"
                                value={domainOptions.find(o => o.key === form.domainFrom)}
                                onChange={(selected) => handleChange({ target: { name: 'domainFrom', value: selected.key } })}
                                options={domainOptions}
                            />
                        </div>
                    </div>

                    {/* Delivery Method */}
                    <div className="row align-items-center mb-2">
                        <label className="col-4 col-form-label">Delivery Method:</label>
                        <div className="col-8">
                            <Select
                                {...commonSelectProps}
                                id="deliveryMethod"
                                name="deliveryMethod"
                                value={methodOptions.find(m => m.key === form.deliveryMethod)}
                                onChange={(selected) => handleChange({ target: { name: 'deliveryMethod', value: selected.key } })}
                                options={methodOptions}
                            />
                        </div>
                    </div>

                    {/* Custom SMTP fields */}
                    {form.deliveryMethod === 'custom' && (
                        <>
                            <div className="row align-items-center mb-2">
                                <label className="col-4 col-form-label">SMTP Server:</label>
                                <div className="col-8">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        name="transportServer"
                                        value={form.transportServer}
                                        onChange={handleChange}
                                        placeholder="smtp.example.com"
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center mb-2">
                                <label className="col-4 col-form-label">Port:</label>
                                <div className="col-8">
                                    <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name="transportPort"
                                        value={form.transportPort}
                                        onChange={handleChange}
                                        placeholder="587"
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center mb-2">
                                <label className="col-4 col-form-label">Username:</label>
                                <div className="col-8">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        name="transportUser"
                                        value={form.transportUser}
                                        onChange={handleChange}
                                        placeholder="user@example.com"
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center mb-4">
                                <label className="col-4 col-form-label">Password:</label>
                                <div className="col-8">
                                    <div className="input-group">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className="form-control form-control-sm"
                                            name="transportPass"
                                            value={form.transportPass}
                                            onChange={handleChange}
                                            placeholder="••••••••"
                                        />
                                        <button
                                            type="button"
                                            className={"btn " + (showPassword ? "btn-secondary" : "btn-outline-secondary")}
                                            onClick={() => setShowPassword(!showPassword)}
                                            title={showPassword ? "Hide Password" : "Show Password"}
                                            aria-label={showPassword ? "Hide Password" : "Show Password"}
                                            data-toggle="tooltip"
                                            data-placement="top"
                                        >
                                            <i className="far fa-eye"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
export default ComDeliveryEditor;